import { RequestQuoteWizard } from '../components/request-quote-wizard';
import { QuoteRequestComplete } from '../components/quote-request-complete';
import { ReportedFindingsMachineContext } from '../machine/context';

export function RequestQuoteWizardScreen() {
    ReportedFindingsMachineContext.useActorRef();

    const isSelectQuote = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('selectRequestQuoteItems')
            || state.matches('requestQuote')
            || state.matches('confirmRequestQuote')
    );

    const isQuoteRequestComplete = ReportedFindingsMachineContext.useSelector(
        (state) => state.matches('quoteRequestComplete')
    );

    return (
        <>
            {isSelectQuote && <RequestQuoteWizard />}
            {isQuoteRequestComplete && <QuoteRequestComplete />}
        </>
    );
}
